import * as React from 'react';
import { useTheme, Box, Unstable_Grid2 as Grid, Paper, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { StyledSectionHeader } from '../../../../themes/styled-components';

interface IEtlResourcesCard {
  client?: IClient;
}

export default function EtlResourcesCard (props: IEtlResourcesCard) {
  
  const theme = useTheme();
  
  const tableHeaderStyle = {
    color: theme.palette.text.secondary,
    fontSize: '0.7rem', 
    fontWeight: '900',
    height: '40px',
    margin: 0,
    padding: 0
  };

  const tableCellStyle = {
    color: theme.palette.text.secondary,
    fontSize: '0.7rem',
    height: '40px',
    padding: 0
  };  
  
  return (
    <Box sx={{ height: '100%' }}>
      <Paper sx={{ height: '100%', p: 2}}>
        <StyledSectionHeader>ETL Cloud Resources</StyledSectionHeader>
        <TableContainer sx={{ overflow: 'hidden' }}>
          <Table sx={{ width: '100%', }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="left" style={{ width: '10%', ...tableHeaderStyle }}>Resource</TableCell>
                <TableCell align="left" style={{ width: '10%', ...tableHeaderStyle }}>Bronze</TableCell>
                <TableCell align="left" style={{ width: '10%', ...tableHeaderStyle }}>Silver</TableCell>
                <TableCell align="left" style={{ width: '10%', ...tableHeaderStyle }}>Gold</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow key={0} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                <TableCell align="left" style={{...tableCellStyle}}>Glue Catalog</TableCell>
                <TableCell align="left" style={{...tableCellStyle}}>{props.client?.AmaPipeline?.BronzeDb}</TableCell>
                <TableCell align="left" style={{...tableCellStyle}}>{props.client?.AmaPipeline?.SilverDb}</TableCell>
                <TableCell align="left" style={{...tableCellStyle}}>{props.client?.AmaPipeline?.GoldDb}</TableCell>
              </TableRow>
              <TableRow key={1} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                <TableCell align="left" style={{...tableCellStyle}}>Glue Job</TableCell>
                <TableCell align="left" style={{...tableCellStyle}}>ama_shared_preprocess_script</TableCell> 
                <TableCell align="left" style={{...tableCellStyle}}>{props.client?.AmaPipeline?.SilverGlueJobName}</TableCell>
                <TableCell align="left" style={{...tableCellStyle}}>{props.client?.AmaPipeline?.GoldGlueJobName}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
}